import { render, staticRenderFns } from "./FbLogin.vue?vue&type=template&id=26230cab&scoped=true&"
import script from "./FbLogin.vue?vue&type=script&lang=js&"
export * from "./FbLogin.vue?vue&type=script&lang=js&"
import style0 from "./FbLogin.vue?vue&type=style&index=0&id=26230cab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26230cab",
  null
  
)

export default component.exports